import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modal-sanction-type-mel',
  templateUrl: './modal-sanction-type-mel.component.html',
  styleUrls: ['./modal-sanction-type-mel.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSanctionTypeMelComponent {

  @Input() visible = true;
  @Input() matrix: string[][] = [];
  @Output() handleClose: EventEmitter<void> = new EventEmitter();

  constructor() {
  }
}
